<!-- 监控中心 -->
<style lang="scss" scoped>
.jiankong {
  position: absolute;
  left: 107px;
  top: 135px;
}
.kanban {
  .jk-content {
    height: 152px;
    width: 100%;
    width: 416px;
    .jk-number {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-top: 20px;
      .num-item {
        width: 88px;
        .sub-text,
        .top-text {
          width: 100%;
          text-align: center;
        }
        .top-text {
          color: #ffffff;
          font-weight: 500;
          font-size: 18px;
          line-height: 27px;
        }
        .sub-text {
          font-family: "dina";
          font-weight: 500;
          font-size: 48px;
          line-height: 55px;
          margin-top: 10px;
        }
        .normal-color {
          color: #2d82ff;
        }
        .error-color {
          color: #f1802f;
        }
      }
      .item-margin {
        margin: 0 42px;
      }
    }
  }
}
.kanban2 {
  margin-top: 20px;
  .jiankong-video {
    width: 416px;
    height: 234px;
  }
}
.returnScence {
  position: absolute;
  width: 144px;
  height: 56px;
  left: 536px;
  top: 135px;
  cursor: pointer;
  background-image: url("../../../../assets/pagesImg/returnBtn-normal.png");

  &:hover {
    background-image: url("../../../../assets/pagesImg/returnBtn-active.png");
  }
}
.jiankong-content {
  pointer-events: all;
  position: relative;
}
.ifram-small {
  // position: relative;
  width: 340px;
  height: 183px;
  overflow: hidden;
  background-color: transparent;
  iframe {
    // width: 1920px;
    // height: 1080px;
    top: 0;
    left: 0;
    transform-origin: top left;
    // transform: scale(0.4);
  }
}
.dialogContent {
  position: absolute;
  width: 416px;
  right: 43px;
  top: 135px;
  .container-div {
    padding: 20px;
    .container-item {
      color: white;
      display: flex;
      justify-content: space-between;
    }
  }

  .large-btn {
    position: absolute;
    width: 29px;
    height: 20px;
    bottom: 31px;
    right: 61px;
    background-image: url("../../../../assets/compImg/parking/imgIcon.png");
    background-size: cover;
  }
}
.ifram-large {
  position: absolute;
  top: 211px;
  left: 600px;
  width: 768px;
  height: 432px;
  overflow: hidden;
  background-color: transparent;
  iframe {
    // width: 1920px;
    // height: 1080px;
    top: 0;
    left: 0;
    // transform-origin: top left;
    // transform: scale(0.4);
  }
  .close {
    position: absolute;
    top: 19px;
    right: 19px;
    width: 48px;
    height: 36px;
    background-image: url("../../../../assets/cut/close-img.png");
    background-size: 100%;
    cursor: pointer;
  }
}
</style>
<template>
  <div class="jiankong-content">
    <div class="returnScence" @click="returnScence"></div>
    <div class="jiankong">
      <div class="kanban">
        <custom-plane
          title="监控设备"
          :iconImg="require('@/assets/pagesImg/icon-jiankong.png')"
        >
          <div class="jk-content">
            <div class="jk-number">
              <div class="num-item">
                <div class="top-text">正常数量</div>
                <div class="sub-text normal-color">
                  {{ normal }}
                </div>
              </div>
              <div class="num-item item-margin">
                <div class="top-text">待机数量</div>
                <div class="sub-text">{{ standby }}</div>
              </div>
              <div class="num-item">
                <div class="top-text">故障数量</div>
                <div class="sub-text error-color">
                  {{ fault }}
                </div>
              </div>
            </div>
          </div>
        </custom-plane>
      </div>
      <!-- <div class="kanban2">
     <custom-plane>
       <div class="jiankong-video"></div>
     </custom-plane>
   </div> -->
    </div>
    <div class="dialogContent" v-if="isShowDialog">
      <pannel-box
        headerName="监控"
        :headerData="showDataList"
        @close="closeDialog"
      >
        <!-- :src="showDataList.monitorURL" -->
        <div class="ifram-small">
          <flv-player-ws :url="showDataList.monitorURL" />

          <!-- <iframe
            id="video"
            :src="showDataList.monitorURL"
            width="100%"
            height="100%"
            frameborder="0"
            allowfullscreen="allowfullscreen"
          ></iframe> -->
        </div>

        <div class="large-btn" @click="isIframe = !isIframe"></div>
      </pannel-box>
    </div>
    <div class="ifram-large" v-if="isIframe">
      <!-- <iframe
        :src="showDataList.monitorURL"
        width="100%"
        height="100%"
        frameborder="0"
        allowfullscreen="allowfullscreen"
      ></iframe> -->
      <flv-player-ws :url="showDataList.monitorURL" />
      <div class="close" @click="isIframe = false"></div>
    </div>
  </div>
</template>

<script>
import { getMonitorData, getEqpStatus } from "@/api";
import bus from "@/components/three-scene/Bus.js";
import { getEqpInfo } from "@/api";
export default {
  data() {
    return {
      isIframe: false,
      isShowDialog: false,
      timeValue: "day",
      dataList: [],
      monitorData: {},
      normal: "-",
      standby: "-",
      fault: "-",
      showDataList: {},
      showDialog: false,
      timer: null,
    };
  },
  created() {
    this.getOutStatus();
    this.getMoData();
    this.timer = setInterval(() => {
      this.getOutStatus();
      this.getMoData();
    }, 30 * 60 * 1000);
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  },
  mounted() {
    this.$store.state.threeEvent.intoJk = true;
    bus.emit("openFloorLabel", true);
    bus.emit("mit", true);
    bus.emit("showFloorPoint", "监控", true);
    bus.on("dialogNumber", this.showDialogContainer);
    // bus.on("parkingArea2", this.clickParking);
    bus.on("closeShowDialog", (data) => {
      this.isShowDialog = data;
      this.isIframe = false;
    });
  },
  methods: {
    closeDialog() {
      this.isShowDialog = false;
      this.isIframe = false;
    },
    initFrame() {
      document.getElementById("video").style.height =
        document.getElementById("video").scrollWidth * 0.8 + "px";
    },
    async getOutStatus() {
      let { data: res } = await getEqpStatus({
        buildNo: "07",
        floor: "A01",
        module: "AF",
      });
      bus.emit("getOutStatus", res);
    },
    returnScence() {
      bus.emit("back");
      bus.emit("monitoring");
      this.isShowDialog = false;
      this.isIframe = false;
    },
    async showDialogContainer(eqpCode) {
      if (this.isShowDialog) {
        this.isShowDialog = false;
        this.isIframe = false;
      }
      let { data: res } = await getEqpInfo({ eqpCode });
      this.showDataList = res.baseData;
      this.isShowDialog = true;
    },
    timeChangeEvent(type) {
      console.log("时间变换", type);
    },
    async getMoData() {
      let { data: res } = await getMonitorData();
      this.normal = res.monitor.normal;
      this.standby = res.monitor.standby;
      this.fault = res.monitor.fault;
    },
    // setNum(val, status, num) {
    //   if (!val) {
    //     return "-";
    //   } else {
    //     return val;
    //   }
    // },
  },
};
</script>
